var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.to)?_c('div',{staticClass:"dropdown-item"},[_vm._t("default")],2):_c('a',{staticClass:"dropdown-item",attrs:{"href":_vm.to,"target":_vm.openLinkInNewTab ? '_blank' : '_self'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }